import { render, staticRenderFns } from "./UpdateLicense.vue?vue&type=template&id=19aeee90"
import script from "./UpdateLicense.vue?vue&type=script&lang=js"
export * from "./UpdateLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports